import {
  SET_ACTIVE_STREAM,
  SET_CALLER,
  SET_CALLING,
  SET_CALL_TYPE,
  SET_CURRENT_MEETING_ID,
  SET_DRAWER,
  SET_DRAWER_CHILDREN,
  SET_INCOMING_CALL,
  SET_LOCAL_STREAM,
  SET_MODAL_LOADING,
  SET_REPORT_PANEL_DOCKED,
  SET_MY_CALL_DATA,
  SET_NETWORK_STATUS,
  SET_ON_CALL,
  SET_OUTGOING_CALL,
  SET_PEER,
  SET_POPUP_CHILDREN,
  SET_REMOTE_PEER,
  SET_REMOTE_STREAM,
  SET_SECOND_POPUP_CHILDREN,
  SET_SHOW_POPUP,
  SET_SHOW_SECOND_POPUP,
  SET_SOCKET,
  SET_TRACKS,
  SET_USERS_ON_CALL,
} from './types';

export const setDrawer = (payload) => ({
  type: SET_DRAWER,
  payload,
});

export const setDrawerChildren = (payload, size) => ({
  type: SET_DRAWER_CHILDREN,
  payload,
  size,
});

export const setLocalStream = (payload) => ({
  type: SET_LOCAL_STREAM,
  payload,
});

export const setActiveStream = (payload) => ({
  type: SET_ACTIVE_STREAM,
  payload,
});

export const setOnCall = (payload) => ({
  type: SET_ON_CALL,
  payload,
});

export const setOutgoingCall = (payload) => ({
  type: SET_OUTGOING_CALL,
  payload,
});

export const setIncomingCall = (payload) => ({
  type: SET_INCOMING_CALL,
  payload,
});

export const setCaller = (payload) => ({
  type: SET_CALLER,
  payload,
});

export const setRemoteStream = (payload) => ({
  type: SET_REMOTE_STREAM,
  payload,
});

export const setSocket = (payload) => ({
  type: SET_SOCKET,
  payload,
});

export const setPeer = (payload) => ({
  type: SET_PEER,
  payload,
});

export const setCalling = (payload) => ({
  type: SET_CALLING,
  payload,
});

export const togglePopup = (payload) => ({
  type: SET_SHOW_POPUP,
  payload,
});

export const setPopupChildren = (payload, onDismiss) => ({
  type: SET_POPUP_CHILDREN,
  payload,
});

export const setRemotePeer = (payload) => ({
  type: SET_REMOTE_PEER,
  payload,
});

export const setTracks = (payload) => ({
  type: SET_TRACKS,
  payload,
});

export const setCallType = (payload) => ({
  type: SET_CALL_TYPE,
  payload,
});

export const setUsersOnCall = (payload) => ({
  type: SET_USERS_ON_CALL,
  payload,
});

export const setCurrentMeetingId = (payload) => ({
  type: SET_CURRENT_MEETING_ID,
  payload,
});

export const setMyCallData = (payload) => ({
  type: SET_MY_CALL_DATA,
  payload,
});

export const setNetworkStatus = (payload) => ({
  type: SET_NETWORK_STATUS,
  payload,
});

export const toggleSecondPopup = (payload) => ({
  type: SET_SHOW_SECOND_POPUP,
  payload,
});

export const setSecondPopupChildren = (payload, onDismiss) => ({
  type: SET_SECOND_POPUP_CHILDREN,
  payload,
});

export const setModalLoading = (payload) => ({
  type: SET_MODAL_LOADING,
  payload,
});

export const setReportPanelDocked = (payload) => ({
  type: SET_REPORT_PANEL_DOCKED,
  payload,
});
